import script from "./DashboardCaseloadAdditions.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashboardCaseloadAdditions.vue?vue&type=script&setup=true&lang=ts"

import "./DashboardCaseloadAdditions.vue?vue&type=style&index=0&id=b3fb05bc&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3fb05bc"]])

export default __exports__